<template>
  <div class="sidebar-top d-print-none">
    <span class="report-icn d-none d-md-block" :class="product.icon" />
    <h3 class="text-center">{{ header }}</h3>
    <slot name="caption" />
    <Messages id="buyReport" />
    <BuyButton
      v-if="hasCallToActionButton || !isLoggedIn"
      :class="['btn-success', buttonClass]"
      :style="[isPromotionalReport ? { 'margin-bottom': '0px !important' } : {}]"
      :disabled="disabled"
      @buy="buy">
      {{ buttonTitle || actionTitle }}
    </BuyButton>
    <span class="card-info" v-if="isPromotionalReport">
      <a :href="rulesUrl" class="card-subtext small">{{ $t('report.promotion.rule.title') }}</a>
    </span>
    <span class="card-info mt-11">
      {{ $t('report.price') }} <span class="card-info-value">{{ priceValue }}</span>
    </span>
    <span class="sidebar-caption text-center" v-if="product.price && this.$price(product.price)">
      {{ $t('report.priceHint', { vatPercent }) }}
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BuyButton from './BuyButton';
import Messages from './Messages';

export default {
  props: {
    product: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    buttonClass: { type: String, default: 'mt-8' },
    price: [Number, String],
    buttonTitle: String,
    scope: String,
    hasCallToActionButton: { type: Boolean, default: true },
  },
  components: {
    BuyButton,
    Messages,
  },
  data() {
    return {
      isPromotionalReport: false,
    };
  },
  computed: {
    ...mapGetters('product', ['vatPercent']),
    ...mapGetters('session', ['isLoggedIn']),
    header() {
      return this.scope ? this.$t(`${this.scope}.header`) : this.product.title;
    },
    actionTitle() {
      if (this.isPromotionalReport) return this.$t('report.promotion.todayIsFree');
      if ((this.product.price || 0) <= 0) return this.$t('order');
      return this.$t(this.scope ? `${this.scope}.action` : 'buy');
    },
    priceValue() {
      if (typeof this.price === 'string') {
        return this.price;
      }

      return this.$price(this.price || this.product.price || 0, undefined, this.isPromotionalReport);
    },
    rulesUrl() {
      return this.$generateUrl(this.$t('report.promotion.rule.url'));
    },
  },
  methods: {
    ...mapActions('purchase', ['promotionReport', 'freeReport', 'checkIsPromotionalReport']),
    ...mapActions('alerts', ['showMessage']),
    buy() {
      if (this.product.price === 0) {
        return this.freeReport({ productCode: this.product.productCode })
          .then(({ status, productCode }) => {
            if (status === 'success') {
              this.$router.push({ name: `purchaseHistory-${this.$i18n.locale}`, query: { product: productCode }, params: { lang: this.$i18n.locale } });
            } else {
              this.showMessage({ target: 'buyReport', type: 'danger', text: this.$t('errors.appError') });
            }
          });
      }
      if (this.isPromotionalReport) {
        return this.promotionReport({ productCode: this.product.productCode })
          .then(({ status, productCode }) => {
            if (status === 'success') {
              this.$router.push({ name: `purchaseHistory-${this.$i18n.locale}`, query: { product: productCode }, params: { lang: this.$i18n.locale } });
            } else {
              this.showMessage({ target: 'buyReport', type: 'danger', text: this.$t('errors.appError') });
            }
          });
      }

      return this.$emit('buy');
    },
  },
  created() {
    if (this.product.promotion === 'todayIsFree' && this.isLoggedIn) {
      this.checkIsPromotionalReport({ productCode: this.product.productCode })
        .then((data) => {
          this.isPromotionalReport = !!data.isStillPromotional;
        });
    }
  },
};
</script>
